// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"korean-rectangle"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 4V20H2L2 4L22 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 4V20L2 20L2 4L22 4Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14 12V9H17.5294C17.6594 9 17.7647 9.09594 17.7647 9.21429V11.7857C17.7647 11.9041 17.6594 12 17.5294 12H14ZM14 12V15M18 15V14.4565C18 14.3935 17.9695 14.3337 17.9167 14.2929L15.5744 12.488L15.4792 12.4146M6 15V9M10 15V14.2531C10 14.1839 9.95544 14.119 9.88035 14.0788L6.5355 12.1531M10 9V9.74687C10 9.81607 9.95544 9.88102 9.88035 9.92124L6.5355 11.8469","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-korean-rectangle')
export default class KoreanRectangleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'korean-rectangle',
    }
  }
}
